import { ThreeElements } from '@react-three/fiber';
import { useMemo } from 'react';
import * as THREE from 'three';

type ArrowHelperProps = ThreeElements['group'] & {
  origin: THREE.Vector3;
  direction: THREE.Vector3;
  length?: number;
  shaftRadius?: number;
  headRadius?: number;
  color?: string;
};

export const ArrowHelper = ({
  origin,
  direction,
  length = 1,
  shaftRadius = 0.01,
  headRadius = 0.04,
  color = '#ff2060',
  ...restProps
}: ArrowHelperProps) => {
  const shaftLength = length * 0.7;
  const headLength = length * 0.3;

  // Compute quaternion to align Z-axis with direction
  const quaternion = useMemo(() => {
    const quat = new THREE.Quaternion();
    quat.setFromUnitVectors(new THREE.Vector3(0, 1, 0), direction.clone().normalize());
    return quat;
  }, [direction]);

  return (
    <group position={origin} quaternion={quaternion} {...restProps}>
      {/* Shaft */}
      <mesh position={[0, shaftLength / 2, 0]}>
        <cylinderGeometry args={[shaftRadius, shaftRadius, shaftLength, 8]} />
        <meshStandardMaterial color={color} />
      </mesh>

      {/* Head */}
      <mesh position={[0, shaftLength + headLength / 2, 0]}>
        <coneGeometry args={[headRadius, headLength, 16]} />
        <meshStandardMaterial color={color} />
      </mesh>
    </group>
  );
};
